import { useRef, useState } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
} from 'approot/activity-builder/activity-builder-drawer';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';
import Tabs from 'approot/shared/tabs/tabs';
import { SettingProps } from '../interactive-response-categorise.constants';
import InteractiveResponseCategoriseDetails from './interactive-response-categorise-details';
import InteractiveResponseCategoriseSolution from './interactive-response-categorise-solution';
import InteractiveResponseCategoriseItems from './interactive-response-categorise-items';
import * as Styled from '../../sequence/settings/interactive-response-settings.style';

type Props = SettingProps & {
  onCloseChildDrawer?: () => void;
};

const Content = (props: Props) => {
  const { onCloseChildDrawer } = props;
  const { closeDrawer } = useActivityBuilderContext();
  const ref = useRef<HTMLDivElement | null>(null);

  const [tab, setTab] = useState<number>(3);

  const onClose = onCloseChildDrawer ? onCloseChildDrawer : closeDrawer;
  return (
    <ActivityBuilderDrawerWrapper onCloseByEscape={onClose}>
      <ActivityBuilderDrawerHeader
        title="Grouping"
        isBack={!!onCloseChildDrawer}
        onClose={onClose}
      />
      <Styled.InteractiveResponseTabs>
        <Tabs
          ariaDescription="Interactive edit setting tab options"
          contentPanelId="content"
          options={[
            { label: 'Details', value: 3 },
            { label: 'Content', value: 1 },
            { label: 'Solution', value: 2 },
          ]}
          activeTab={tab}
          onSelect={tab => setTab(tab.value as number)}
        />
      </Styled.InteractiveResponseTabs>

      <ActivityBuilderDrawerContent ref={ref}>
        <div id="content" tabIndex={-1}>
          {tab === 3 && <InteractiveResponseCategoriseDetails {...props} />}
          {tab === 1 && <InteractiveResponseCategoriseItems {...props} />}
          {tab === 2 && <InteractiveResponseCategoriseSolution {...props} />}
        </div>
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

const InteractiveResponseCategoriseSettings = (props: Props) => (
  <FileDropperContextProvider>
    <Content {...props} />
  </FileDropperContextProvider>
);

export default InteractiveResponseCategoriseSettings;
